import { render, staticRenderFns } from "./incidentReportSettings.vue?vue&type=template&id=051759e1"
import script from "./incidentReportSettings.vue?vue&type=script&lang=js"
export * from "./incidentReportSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports